export class HeartManager {
  private _num = 0;

  get() {
    this._num++;
  }

  robbed() {
    this._num--;
  }

  get num() {
    return this._num;
  }
}
